/**
 * @Author: 韩祺涛
 * @Date: 2023-03-10
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    selectFeatureTree: {}
  },
  getters: {
    selectFeatureTree: state => state.selectFeatureTree
  },
  mutations: {
    setSelectFeatureTreeId: (state, data) => {
      state.selectFeatureTree = data
    }
  },
  actions: {
    handleSelectFeatureTreeId (selectFeatureTree, data) {
      selectFeatureTree.commit('selectFeatureTree', data)
    }
  }
}